module.exports = __webpack_public_path__ + "img/profile-user.d463c90a.svg";